<template>
  <section class="ya-te-bg-gray py-6">
    <div class="co-container-md px-4">
      <div class="flex flex-wrap">
        <div class="w-full text-center sm:w-1/2 sm:pr-2 md:pr-3">
          <img
            class="mb-5 sm:mb-0"
            src="~/assets/images/YaTe/YaTeCounseling/Special/special-simple-1.svg"
            alt="Amazonギフトカード500円分プレゼント"
            width="482"
            height="171"
            loading="lazy"
          >
        </div>
        <div class="w-full text-center sm:w-1/2 sm:pl-2 md:pl-3">
          <img
            src="~/assets/images/YaTe/YaTeCounseling/Special/special-simple-2.svg"
            alt="受講料10,000円割引"
            width="482"
            height="171"
            loading="lazy"
          >
          <div class="mt-1 text-left text-[0.625rem] leading-normal text-co-gray-500">
            ※本件と別の割引・減額制度を併用することはできません。2つ以上の割引・減額制度の適用対象となる場合、割引額が最も大きいものが適用されます。
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<style scoped>
@import url("~/assets/css/YaTe/YaTeCommon/YaTeCommon.css");
</style>

